class Header {
    constructor() {
        this.body = document.querySelector('body');
        this.checkScrollY();
        window.addEventListener('scroll', (e) => {
            (window.scrollY >= 100) ? this.body.classList.add('scrolled') : this.body.classList.remove('scrolled');
        })
    }

    checkScrollY() {
        (window.scrollY >= 100) ? this.body.classList.add('scrolled') : this.body.classList.remove('scrolled');
    }
}

export default Header;